import { useEffect, useState } from "react";
import ManageTourFirstStep from "./ManageTourFirstStep";
import ManageTourForthStep from "./manageTourForthStep";
import ManageTourSecondStep from "./ManageTourSecondStep";
import ManageTourThirdStep from "./manageTourThirdStep";
import ManageTourFiveStep from "./manageTourFiveStep";
import { StickyContainer, Sticky } from "react-sticky";
import { useSearchParams } from "react-router-dom";

const ManageTourStepper = () => {
  const [stepTab, setStepTab] = useState(0);
  const [searchParams] = useSearchParams();
  // if (stepOfUrlQury) {
  //   setStepTab(stepOfUrlQury);
  //   console.log(stepTab);
  // }
  const [width, setWidth] = useState(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  const nextStepTab = () => {
    setStepTab(stepTab + 1);
  };
  const prevStepTab = () => {
    if (stepTab > 0) {
      setStepTab(stepTab - 1);
    }
  };

  const [titleOfTour, setTitleOfTour] = useState("");
  const [packageNumber, setPackageNumber] = useState("");
  useEffect(() => {
    const stepOfUrlQury = searchParams.get("step");
    const titleQueryParam = searchParams.get("title");
    const packageNumberQueryParam = searchParams.get("packageNumber");
    setTitleOfTour(titleQueryParam);
    setPackageNumber(packageNumberQueryParam);
    if (stepOfUrlQury) {
      setStepTab(parseInt(stepOfUrlQury));
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const formRenderHandler = () => {
    switch (stepTab) {
      case 0: {
        return <ManageTourFirstStep nextStepTab={nextStepTab} />;
      }
      case 1: {
        return (
          <ManageTourSecondStep
            nextStepTab={nextStepTab}
            prevStepTab={prevStepTab}
          />
        );
      }
      case 2: {
        return (
          <ManageTourThirdStep
            nextStepTab={nextStepTab}
            prevStepTab={prevStepTab}
          />
        );
      }
      case 3: {
        return (
          <ManageTourForthStep
            nextStepTab={nextStepTab}
            prevStepTab={prevStepTab}
          />
        );
      }
      case 4: {
        return <ManageTourFiveStep prevStepTab={prevStepTab} />;
      }
      default: {
        return;
      }
    }
  };
  return (
    <div className="py-5 md:p-5 shadow-lg rounded-md border border-stone-100 bg-white">
      <div className="flex flex-col md:flex-row gap-2 md:gap-6 px-4 md:px-0">
        <div className="flex gap-2">
          <div className="text-slate-400">شماره تور:</div>
          <div>{parseInt(packageNumber)}</div>
        </div>
        <div className="flex gap-2">
          <div className="text-slate-400">عنوان تور:</div>
          <div>{titleOfTour}</div>
        </div>
      </div>
      <div className={`md:mx-4 py-4 px-4 md:px-0 md:p-4`}>
        <div className="flex items-center">
          <div
            className={`flex items-center relative cursor-pointer ${
              stepTab === 0
                ? "text-white"
                : stepTab > 0
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            onClick={() => setStepTab(0)}
          >
            <div
              className={`rounded-full transition duration-1000 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 0
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 0
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 0
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              تعریف تور
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-1000 ease-in-out ${
              stepTab > 0 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-pointer ${
              stepTab === 1
                ? "text-white"
                : stepTab > 1
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            onClick={() => setStepTab(1)}
          >
            <div
              className={`rounded-full transition duration-1000 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 1
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 1
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 1
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              اطلاعات تور
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-1000 ease-in-out ${
              stepTab > 1 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-pointer ${
              stepTab === 2
                ? "text-white"
                : stepTab > 2
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            onClick={() => setStepTab(2)}
          >
            <div
              className={`rounded-full transition duration-1000 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 2
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 2
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                />
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 2
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              قیمت و تاریخ برگزاری
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
              stepTab > 2 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-pointer ${
              stepTab === 3
                ? "text-white"
                : stepTab > 3
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            onClick={() => setStepTab(3)}
          >
            <div
              className={`rounded-full transition duration-1000 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 3
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 3
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                />
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 3
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              برنامه زمانی سفر
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-1000 ease-in-out ${
              stepTab > 3 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-pointer ${
              stepTab === 4
                ? "text-white"
                : stepTab > 4
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            onClick={() => setStepTab(4)}
          >
            <div
              className={`rounded-full transition duration-1000 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 4
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 4
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                />
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 4
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              خدمات تور
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 py-4 md:p-4">{formRenderHandler()}</div>
    </div>
  );
};

export default ManageTourStepper;
